/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ActivityOverviewResponse,
  fetchData: (params: vp.ActivityOverviewRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchUserDataOverview: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.ActivityOverviewResponse>({
    Success: false,
    ErrorMessage: '',
    Statistics: {},
  });
  const [params, setParams] = useState<vp.ActivityOverviewRequest>({
    ToDate: '',
    FromDate: '',
  });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();

  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const ApiResponse = await api.fetchActivityOverview(params, source);

      setResponse(ApiResponse);
      setShouldFetchData(false);
      setDataFetchingInfo(false);
    };

    if (shouldFetchData) void loadData();

    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    (_params: vp.ActivityOverviewRequest) => {
      setParams(_params);
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Statistics: {},
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchUserDataOverview);
